import Load from './Load';

export default Load;
